import { useEffect, useState } from 'react';
import { acknowledgeInboxItems, inboxSeenStorageKey, parseInboxSeen, unseenInboxCounts } from '@overlayqa/shared/inboxAttention';
import type { FeedItem } from '@overlayqa/shared';

function readSeen(key: string): string[] {
  try { return parseInboxSeen(JSON.parse(localStorage.getItem(key) || '[]')); }
  catch { return []; }
}

export function useInboxBadge(account: string, items: FeedItem[], open: boolean) {
  const key = inboxSeenStorageKey(account);
  const [saved, setSaved] = useState(() => ({ key, seen: readSeen(key) }));
  const seen = saved.key === key ? saved.seen : readSeen(key);
  useEffect(() => {
    const sync = (event: StorageEvent) => {
      if (event.key === key || event.key === null) setSaved({ key, seen: readSeen(key) });
    };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, [key]);
  useEffect(() => {
    if (!open) return;
    // Merge the latest persisted snapshot so another dashboard tab's receipt
    // cannot be lost. Include read rows: marking one unread is not a new arrival.
    const next = acknowledgeInboxItems([...new Set([...readSeen(key), ...seen])], items);
    if (next.length === seen.length) return;
    try { localStorage.setItem(key, JSON.stringify(next)); } catch { /* Keep this session's acknowledgement. */ }
    setSaved({ key, seen: next });
  }, [key, items, open, seen]);
  return unseenInboxCounts(open ? [] : items, seen);
}
